export default __webpack_public_path__ + "static/media/SUMMIT.3ee60756.png";